import React from "react";
import styles from "./NavBar.css";
import axios from "../../../services/api/axios-default";
import envManager from "../../../services/managers/env";
import httpManager from "../../../services/managers/http";
import _Aux from "../../_Aux";
import Modal from "../../Common/Modal/Modal";
import _ from "lodash";
import { HELP_IMG_HOST_URL } from "../../../services/managers/constants";
import pagePreloaderManager from "../../../services/managers/page-preloader";
import alertMessageManager from "../../../services/managers/alert-message";
import { MAILTO_DATA_SCIENCE, EMAIL_DATA_SCIENCE, TOOLTIP_FEEDBACK } from "../../../services/managers/string-literals";

class Help extends React.Component {
  constructor() {
    super();
    this.state = {
      // Utility key-value
      showHelp: false,
      helpData: [],
      uniqueTags: [],
      selectedTags: []
    };

    this.masterHelpData = [];

    // bind 'this' to event handelers
    this.handleShow = this.handleShow.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
  }
  handleShow() {
    pagePreloaderManager.show("Loading");
    // Get URL to post data
    let url = httpManager.getHelpDataEnpoint();

    // Call API to fetch data for drawing of chart
    let self = this;
    axios({ method: "get", url: url })
      .then(function(response) {
        self.setState({
          helpData: [...response.data.Help.Details],
          uniqueTags: self.getUniqueTags(response.data.Help.Details),
          showHelp: true
        });
        self.masterHelpData = [...response.data.Help.Details];
        pagePreloaderManager.hide();
      })
      .catch(function(error) {
        console.error("Catch Error", JSON.stringify(error));
        error = httpManager.transfigureAPIErrorMessages(error);
        pagePreloaderManager.hide();
        alertMessageManager.show("globalAlertError", error);
        return;
      });
  }
  getUniqueTags(responseData) {
    let tempTags = [];
    responseData.forEach(function(obj) {
      tempTags = tempTags.concat(obj.Tags);
    });
    return _.uniq(tempTags).sort();
  }

  handleCloseModal() {
    this.setState({ showHelp: false, selectedTags: [] });
  }

  escFunction(event) {
    //escpae key
    if (event.keyCode === 27 && this.state.showHelp) {
      this.handleCloseModal();
    }
  }
  resetFilter() {
    this.setState({
      helpData: [...this.masterHelpData],
      uniqueTags: this.getUniqueTags(this.masterHelpData),
      selectedTags: []
    });
  }
  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  onTagsClicked(clickedTag) {
    //check if selected tag has
    if (!_.includes(this.state.selectedTags, clickedTag)) {
      this.state.selectedTags.push(clickedTag);
    } else {
      _.pull(this.state.selectedTags, clickedTag);
    }
    if (this.state.selectedTags.length) {
      let helpData = [];
      let masterDataLength = this.masterHelpData.length;
      for (let i = 0; i < masterDataLength; i++) {
        let intersectedTags = _.intersection(this.masterHelpData[i].Tags, this.state.selectedTags);
        if (intersectedTags.length) {
          helpData.push({ ...this.masterHelpData[i] });
        }
      }
      this.setState({ helpData: [...helpData] });
    } else {
      this.setState({ helpData: [...this.masterHelpData] });
    }
  }

  render() {
    //question-answer
    let questionAnswers = (
      <div className="grid__col-md-12 grid__col-sm-12">
        {this.state.helpData.map((help, index) => (
          <div className={styles["each-question-answer-container"]} key={index}>
            <div className={styles["question-container"]}>
              <strong>{help.Question}</strong>
            </div>
            <div
              className={styles["answer-container"]}
              dangerouslySetInnerHTML={{ __html: help.Answer.replace(HELP_IMG_HOST_URL, envManager.getApiEndpointHelpImages()) }}
            />
          </div>
        ))}
      </div>
    );

    //tags
    let tagLinks = [];
    let uniqueTagsLength = this.state.uniqueTags.length;
    for (let i = 0; i < uniqueTagsLength; i++) {
      let className = styles["btn-tag"] + " btn btn--secondary btn--small";
      tagLinks.push(
        <button
          onClick={this.onTagsClicked.bind(this, this.state.uniqueTags[i])}
          key={i}
          className={_.includes(this.state.selectedTags, this.state.uniqueTags[i]) ? className.replace("btn--secondary", "btn--primary") : className}>
          {this.state.uniqueTags[i]}
        </button>
      );
    }

    let tagsDoc = (
      <div className={"grid__col-md-12 grid__col-sm-12 " + styles["tag-container"]}>
        <div className={styles["tag-links"]}>
          <div className={styles["clear-all"]}>
            <button onClick={this.resetFilter} type="button" className="btn btn--link btn--link--negative" title="Remove all filters">
              <i className="fa fa-times" aria-hidden="true" /> Clear All
            </button>
            <p>What kind of FAQs are you looking for? Choose below.</p>
          </div>
          {tagLinks}
        </div>
      </div>
    );
    //Conditionally toggle, Form and thank you message
    let help = this.state.showHelp ? (
      <Modal>
        <div className={"modal-content-container " + styles["help-modal-container"]}>
          <header className="modal__header modal-header" aria-labelledby="modal__title">
            <h3>FAQ Document</h3>
            <small className={styles.note}>
               For further questions, email us at <a href={MAILTO_DATA_SCIENCE}>{EMAIL_DATA_SCIENCE}</a>
            </small>
            <button className="modal__close btn btn--transparent js-modal-close" aria-label="close" onClick={this.handleCloseModal}>
              <i className="icon-cme-card-close icon--medium" />
            </button>
          </header>
          <div className="grid">
            {tagsDoc}
            {questionAnswers}
          </div>
        </div>
      </Modal>
    ) : null;

    return (
      <_Aux>
        <div className={"grid " + styles["chart-help-component-container"]}>
          <div className={"grid__col-md-12 grid__col-sm-12 " + styles["grid-col-section-right"]}>
            <button className="btn btn--link" onClick={this.handleShow}>
              FAQ
            </button>
          </div>
        </div>
        {help}
      </_Aux>
    );
  }
}

export default Help;



// WEBPACK FOOTER //
// ./src/components/Analytics/NavBar/NavBar.js